import { Injectable } from '@angular/core';
import {VirtualPconsDialogComponent} from './virtual-pcons-dialog.component';
import {PeerConnectionApiService} from '../../../services/api/peer-connection/peer-connection-api.service';
import {SnackBarService} from '../../../services/common/snack-bar/snack-bar.service';
import {MatDialog} from '@angular/material/dialog';
import {ConfirmationDialogComponent} from '../../../dialogs/confirmation-dialog/confirmation-dialog.component';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class VirtualPconsDialogService {

  constructor(private peerConnectionApiService: PeerConnectionApiService,
              private snackBarService: SnackBarService,
              public dialog: MatDialog) { }


  addVirtualPcon(pCon, voipPeers, onSuccess = () => {}, onFailure = () => {}): void {
    const dialogRef = this.dialog.open(VirtualPconsDialogComponent, {
      data: {
        isEditMode: false,
        selectedItem: pCon,
        voipPeers
      }
    });

    dialogRef.componentInstance.onApply.subscribe(result => {
      this.peerConnectionApiService.addPCon(result.selectedItem).then(() => {
        dialogRef.close();
        this.snackBarService.display(`"${result.selectedItem.name}" successfully added`);
        onSuccess();
      });
    });
  }

  editVirtualPcon(selection, voipPeers, onSuccess = () => {}, onFailure = () => {}): void {
    this.peerConnectionApiService.getPcon(selection.id).then(pCon => {
      const dialogRef = this.dialog.open(VirtualPconsDialogComponent, {
        data: {
          isEditMode: true,
          selectedItem: _.cloneDeep(pCon),
          voipPeers
        }
      });

      dialogRef.componentInstance.onApply.subscribe(result => {
        this.peerConnectionApiService.editPCon(result.selectedItem, selection.id).then(() => {
          dialogRef.close();
          this.snackBarService.display(`"${result.selectedItem.name}" successfully edited`);
          onSuccess();
        });
      });
    });
  }

  remove(selection, onSuccess = () => {}): void {
    const confirmationMessage = `Are you sure you want to delete the virtual peer connection: "${selection.name}"?`;

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: confirmationMessage
      }
    });

    dialogRef.componentInstance.onApply.subscribe(() => {
      this.peerConnectionApiService.deletePCon(selection.id).then(() => {
        dialogRef.close();
        this.snackBarService.display(`"${selection.name}" successfully deleted`);
        onSuccess();
      });
    });
  }
}
